(function() {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('RelatorioAnualCompletoController', RelatorioAnualCompletoController);

  function RelatorioAnualCompletoController(blockUI, FileSaver, RelatorioAnualService, PeriodoService, i18n, toaster, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.add = add;
    vm.populate = populate;
    vm.exportar = exportar;

    vm.init();

    function init() {
      vm.periodos = PeriodoService.carregaAnosValidosAte(CONSTANTS.ANO_INICIO_ANUARIO);
      vm.periodoSelecionado = vm.periodos[0];
      vm.registrosList = [];
      vm.populate(vm.registrosList);
    }

    function exportar(registroSelecionado) {
      blockUI.start();
      RelatorioAnualService.exportarCompleto({periodo: vm.periodoSelecionado, registro: registroSelecionado})
      .then( (response) => {
        if (response.status === 204) {
          toaster.pop("warning",`${i18n.translate("menu.relatorio.corregedoria.anual")}
          ${i18n.translate("menu.relatorio.corregedoria.anual.completo")}`,
          i18n.translate("relatorio.sem.dados"));
        }

        if (response.status === 200) {
          var blob = new Blob([response.data], { type: 'application/pdf' });
          FileSaver.saveAs(blob, 'anuario-completo.pdf');
        }

      }).finally(() => {
        blockUI.stop();
      });
    }

    function add(registro) {
      vm.data = registro;
      vm.populate(registro.subregistros);
    }

    function populate(lista) {
      if (lista.length === 0) {
        RelatorioAnualService.getRegistrosFilhosBy(vm.data)
        .then( (data) => {
          data = data || [];
          for(let resultado of data) {
            resultado.subregistros = [];
            lista.push(resultado);
          }
        });
      }
    }
  }

})();
